import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import SideMenuState from './sidemenu.state';

const initialState = SideMenuState;

export const sideMenuSlice = createSlice({
  name: 'sideMenu',
  initialState,
  reducers: {
    SET_ACTIVE_PATH: (state, action: PayloadAction<string>) => {
      state.activePath = action.payload;
    },
  },
});

export default sideMenuSlice.reducer;
